(function () {
  if (window.RepeaterVideoPlayerModule) {
    return;
  }

  window.RepeaterVideoPlayerModule = true;

  function initVideoPlayers() {
    const videoContainers = document.querySelectorAll('.columns-with-content__media');

    videoContainers.forEach((container) => {
      const videos = container.querySelectorAll('.columns-with-content__video');

      if (videos.length === 0) return;

      videos.forEach((video) => {
        video.addEventListener('click', () => toggleVideo(video));

        const button = video.previousElementSibling;

        if (!button.classList.contains('columns-with-content__video-button')) {
          return;
        }

        const repeaterContainer = button?.closest('[data-play-label]');
        const playLabel = repeaterContainer?.getAttribute('data-play-label') || 'Play video';
        const pauseLabel = repeaterContainer?.getAttribute('data-pause-label') || 'Pause video';

        const autoplayVideo = Array.from(videos).find((v) => v.autoplay);
        updateButton(button, autoplayVideo && !autoplayVideo.paused, autoplayVideo, playLabel, pauseLabel);

        video.addEventListener('play', () => updateButton(button, true, video, playLabel, pauseLabel));
        video.addEventListener('pause', () => updateButton(button, false, video, playLabel, pauseLabel));
        video.addEventListener('ended', () => updateButton(button, false, video, playLabel, pauseLabel));

        button.addEventListener('click', (e) => {
          e.stopPropagation();
          const visibleVideo = Array.from(videos).find(
            (v) => getComputedStyle(v).display !== 'none' && v.offsetParent !== null
          );
          if (visibleVideo) {
            toggleVideo(visibleVideo);
          }
        });
      });
    });
  }

  function toggleVideo(video) {
    if (video.paused) {
      video.play().catch(console.error);
    } else {
      video.pause();
    }
  }

  function updateButton(button, isPlaying, video = null, playLabel, pauseLabel) {
    if (!button) return;

    const videoDescription = video?.getAttribute('alt') || 'decorative video';

    const playIcon = button.querySelector('.play');
    const pauseIcon = button.querySelector('.pause');

    if (isPlaying) {
      button.classList.remove('paused');
      if (playIcon) playIcon.style.display = 'none';
      if (pauseIcon) pauseIcon.style.display = 'block';
      button.setAttribute('aria-label', `${pauseLabel} ${videoDescription}`);
    } else {
      button.classList.add('paused');
      if (playIcon) playIcon.style.display = 'block';
      if (pauseIcon) pauseIcon.style.display = 'none';
      button.setAttribute('aria-label', `${playLabel} ${videoDescription}`);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoPlayers);
  } else {
    initVideoPlayers();
  }
})();
